import { computed } from 'mobx';

export default class QCCheckModel {
  static modelName = 'QCRuleModel';
  id;
  store;

  constructor(store, qcCheck) {
    this.store = store;
    this.updateFromJson(qcCheck);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      qc_rule_id: this.qc_rule_id,
      stations: this.stations,
      qc_rules: this.qc_rules,
      parameter_id: this.parameter_id,
      seq: this.seq,
      status: this.status,
      interval: this.interval,
      observation_id: this.observation_id,
      timestamp: this.timestamp,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.qc_rule_id = json.qc_rule_id;
    this.stations = json.stations;
    this.qc_rules = json.qc_rules;
    this.parameter_id = json.parameter_id;
    this.seq = json.seq;
    this.status = json.status;
    this.interval = json.interval;
    this.observation_id = json.observation_id;
    this.timestamp = (json.timestamp || '').split('.')[0];
  }
}



// WEBPACK FOOTER //
// ./src/models/QCCheckModel.js